import {Router} from './router'
import {
    ROUTER_LOAD,
    ROUTER_LOAD_PATH,
    ROUTER_LOAD_HASHTAG,
    ROUTER_CLEAR
} from './router.action'


export default (state, action) => {
    switch (action.type) {
        case ROUTER_LOAD:
            return window.location.hash
        case ROUTER_LOAD_PATH:
            return action.path
        case ROUTER_LOAD_HASHTAG:
            if (action.hashtag.isCurrentItinerary()) {
                return action.hashtag.path()
            } else {
                Router.external(action.hashtag.url())
                return null
            }
        case ROUTER_CLEAR:
            return null
    }

    return state
}
